import { makeStyles } from '@material-ui/core/styles';

const MemberCardStyles =
    makeStyles((theme) => ({
        cardContainer: {
            display: "flex",
            //backgroundColor: theme.palette.primary.darkest,
            //color: theme.palette.text.primary,
            margin: `${theme.spacing(4)}px 0px`,
            minHeight: "600px",
            flexDirection: "column" as "column",

            [theme.breakpoints.up("md")]: {
                flexDirection: "row" as "row", //workaround for 'string' is not assignable to type 'FlexDirectionProperty' error
            }
        },
        cardContainerSml: {
            minHeight: "400px",

            [theme.breakpoints.down("sm")]: {
                height: "100%",
            }
        },
        cardContainerMd: {
            minHeight: "600px",
        },
        cardContainerLg: {
            //height: "720px",
        },
        cardSummaryContainer: {
            padding: "60px 50px 80px",
            position: "relative",

            [theme.breakpoints.down("sm")]: {
                order: "2",
                padding: "20px",
            },

            [theme.breakpoints.up("md")]: {
                width: "60%",
            }
        },
        cardSummaryContainerNoImage: {
            width: "100%!important",
        },
        cardSummaryContainerLg: {
            [theme.breakpoints.up("md")]: {
                width: "60%",
            }

        },
        cardImgContainer: {
            verticalAlign: "middle",
            display: "flex",

            [theme.breakpoints.down("sm")]: {
                order: "1",
                height: "500px",
                padding: "0 30px",
            },

            [theme.breakpoints.up("md")]: {
                width: "40%",
            }
        },
        cardImgContainerLg: {
            [theme.breakpoints.up("md")]: {
                width: "40%",
            }
        },
        cardImg: {
            width: "100%",
            height: "100%",
            display: "flex",
        },
        title: {
            margin: `${theme.spacing(2)}px 0`,
        },
        content: {
            marginBottom: theme.spacing(4),
        },
        link: {
            position: "absolute",
            bottom: theme.spacing(4),
            left: theme.spacing(6),
        }
    }));

export default MemberCardStyles;